<template>
  <div class="ui-wall"
       :style="{ 'webkitTransform': transformation, 'transform': transformation, 'width': screenWidth, 'height': screenHeight }"
       @contextmenu="showContextMenu($event)"
  >
  </div>
</template>

<script>
  import interact from 'interactjs';

  export default {
    name: "Wall",

    props: {
      myWall: Object,
      bookingMode: Boolean
    },

    computed: {
      screenWidth() {
        return this.myWall.width + 'px';
      },
      screenHeight() {
        return this.myWall.height + 'px';
      },
      top() {
        return this.myWall.y + 'px';
      },
      left() {
        return this.myWall.x + 'px';
      },
      transformation() {
        return 'translate(' + this.left + ', ' + this.top + ')';
      }
    },

    methods: {
      showContextMenu(event) {
        this.$emit('show-wall-context-menu', event);
      },
      resizeListener (event) {
        // Get coordinates
        let wallX = (parseFloat(this.myWall.x) || 0),
          wallY = (parseFloat(this.myWall.y) || 0),
          wallWidth = event.rect.width,
          WallHeight = event.rect.height;

        wallX += event.deltaRect.left;
        wallY += event.deltaRect.top;

        // Emit the resize/drag move event
        this.$emit('wall-moved', { x: wallX, y: wallY, width: wallWidth, height: WallHeight });
      },
      dragMoveListener (event) {
        // Get coordinates
        let newX = (parseFloat(this.myWall.x) || 0) + event.dx,
          newY = (parseFloat(this.myWall.y) || 0) + event.dy;

        // Emit the resize/drag move event
        this.$emit('wall-moved', { x: newX, y: newY });
      }
    },

    mounted() {
      if (! this.bookingMode) {
        interact(this.$el)
          .draggable({
            onmove: this.dragMoveListener,
            restrict: {
              restriction: 'parent',
              elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
            },
          })
          .resizable({
            // resize from all edges and corners
            edges: { left: true, right: true, bottom: true, top: true },

            // keep the edges inside the parent
            restrictEdges: {
              outer: 'self',
              endOnly: true,
            },

            // minimum size
            restrictSize: {
              min: { width: 10, height: 10 },
            },

            inertia: true,
          })
          .on('resizemove', this.resizeListener);
      }
    }
  }
</script>

<style scoped>
  .ui-wall {
    text-align: center;
    background-color: black;
    position: absolute;

    /* This makes things *much* easier */
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Wall.vue